import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Partners, Banner, Process, PortfolioSection, Pricing, Booking, Expertise } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <Expertise /> {/* Expertise section */}
      <Process /> {/* Process Slider */}
      <Banner /> {/* Banner Section */}
      <PortfolioSection /> {/* Portfolio Section */}
      <Booking /> {/* Booking Form */}
      <Team /> {/* Team section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Pricing /> {/* Pricing Section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;